import React, { useEffect, useState } from "react";
import style from "./style.module.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { FormControlLabel, Checkbox } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { Images } from "../../assets/images/HomePage";
import Button from "@mui/material/Button";
import { images } from "../../assets/images";
// import { Box } from "@mui/material";
// import Modal from 'react-modal'; // Import the Modal component from react-modal

const JobFormScreen = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top of the page when the component mounts
  }, []);
  // const [modalIsOpen, setModalIsOpen] = useState(false);
  // State to manage modal visibility
  //  const[jobApplication, setJobApplication] = useState([])
  const Navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    jobRole: "Select option",
    workExperience: "Select option",
    dob: "", // Date of Birth
    address: "",
    jobType: "Select option",
    introduction: "",
    termsCheckbox: false, // Add termsCheckbox state
    referencePersonDesignation: "",
    coverLetter: null, // Add coverLetter state
    uploadCv: null, // Add uploadCv state
    referencePersonName: "",
    referencePersonEmail: "",
    referencePersonRelationship: "",
    referencePersonLinkedin: "",
    refer: "",
  });

  // Function to validate LinkedIn profile URLs
  const isValidLinkedInURL = (url) => {
    const pattern =
      /^(https?:\/\/)?(www\.)?linkedin\.com\/(in|pub|profile)\/[a-zA-Z0-9_-]+(\/)?$/;
    return pattern.test(url);
  };

  const handleChange = (e) => {
    let { name, value } = e.target;
    if (name === "phone" && value.startsWith("+")) {
      // Show toast message for invalid phone number

      toast.error(
        "Phone number cannot start with '+91'. Please enter a number without '+91'."
      );
      return; // Exit function to prevent updating state
    } else if (name === "refer") {
      // Handle refer radio buttons
      value = e.target.value; // Get the selected refer value
    } else if (name === "termsCheckbox") {
      // Handle refer radio buttons
      value = e.target.checked; // Get the checked value
    }
    // if (name === "referencePersonLinkedin") {

    // }
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 2 * 1024 * 1024) {
        // 2MB limit
        toast.warn(
          "File size exceeds 2MB. Please upload a file smaller than 2MB."
        );
        return;
      }
      if (file.type !== "application/pdf") {
        toast.warn("Invalid file type. Please upload a PDF file.");
        return;
      }
      setFormData({
        ...formData,
        coverLetter: file,
      });
    }
  };

  const handleUploadCv = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 2 * 1024 * 1024) {
        // 2MB limit
        toast.warn(
          "File size exceeds 2MB. Please upload a file smaller than 2MB."
        );
        return;
      }
      if (file.type !== "application/pdf") {
        toast.warn("Invalid file type. Please upload a PDF file.");
        return;
      }
      setFormData({
        ...formData,
        uploadCv: file,
      });
    }
  };

  const handleOpenFile = () => {
    if (formData.coverLetter) {
      // Open the uploaded file in a new window
      window.open(URL.createObjectURL(formData.coverLetter));
    }
  };

  const handleOpenCv = () => {
    if (formData.uploadCv) {
      // Open the uploaded file in a new window
      window.open(URL.createObjectURL(formData.uploadCv));
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault(); // Prevent default form submission
    setLoading(true);
    // Email validation

    const emailPattern = /^\S+@\S+\.\S+$/;
    if (!emailPattern.test(formData.email)) {
      toast.error("Please enter a valid email address.");
      setLoading(false);

      return;
    }

    // Phone number validation
    const phonePattern = /^\+?\d{10,}$/;
    if (!phonePattern.test(formData.phone)) {
      toast.error("Please enter a valid phone number.");
      setLoading(false);
      return;
    }
    if (!isValidLinkedInURL(formData.referencePersonLinkedin)) {
      // Display error message for invalid LinkedIn URL
      toast.error("Please enter a valid LinkedIn profile URL.");
      setLoading(false);
      return;
    }
    // Check if all required fields are filled
    const requiredFields = [
      "name",
      "email",
      "phone",

      "dob",
      "introduction",
      "referencePersonDesignation",
      "referencePersonName",
      "referencePersonEmail",
      "referencePersonRelationship",
      "referencePersonLinkedin",
      "refer",
    ];
    const requiredFields2 = ["jobRole", "workExperience", "jobType", "address"];
    for (const field of requiredFields2) {
      if (!formData[field]) {
        setLoading(false);
        toast.error(`Please enter a valid ${field}`);
        return;
      }
    }
    for (const field of requiredFields) {
      if (
        !formData[field] ||
        formData[field].length < 4 ||
        formData[field].length > 40
      ) {
        setLoading(false);
        toast.error(
          `Please enter a valid ${field} with length between 4 to 20 characters.`
        );
        return;
      }
    }

    try {
      // Create FormData object to send files along with other form data
      const formDataToSend = new FormData();

      // Append text fields to FormData object
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });

      // Append file fields to FormData object
      if (!formData.coverLetter || formData.coverLetter.size > 5242880) {
        // 5MB limit
        setLoading(false);
        toast.error("Please upload a cover letter smaller than 5MB.");
        return;
      }
      formDataToSend.append("coverLetter", formData.coverLetter);

      if (!formData.uploadCv || formData.uploadCv.size > 5242880) {
        // 5MB limit
        setLoading(false);
        toast.error("Please upload a resume/CV smaller than 5MB.");
        return;
      }
      formDataToSend.append("uploadCv", formData.uploadCv);

      if (!formData.termsCheckbox) {
        setLoading(false);
        toast.error("Please accept the terms and conditions.");
        return;
      }

      // Send form data to backend
      const response = await fetch(
        "https://job-application-mindtech.onrender.com/api/job-applications",
        {
          method: "POST",
          body: formDataToSend,
        }
      );

      // Check if request was successful
      if (response.ok) {
        // setModalIsOpen(true); // Open modal upon successful form submission
        // console.log(response.json());
        toast.success("Job application submitted successfully!");
        setTimeout(() => {
          Navigate("/");
        }, 3000);

        // Reset form data after successful submission
        setFormData({
          name: "",
          email: "",
          phone: "",
          jobRole: "",
          workExperience: "",
          dob: "", // Date of Birth
          address: "",
          jobType: "",
          introduction: "",
          termsCheckbox: false, // Add termsCheckbox state
          referencePersonName: "",
          referencePersonDesignation: "",
          referencePersonEmail: "",
          referencePersonRelationship: "",
          referencePersonLinkedin: "",
          refer: "",
          // Reset form fields
        });
        setLoading(false);
      } else {
        toast.error("Failed to submit job application.");
        // Handle error
      }
    } catch (error) {
      toast.error("Error submitting job application.");
      // Handle error
    } finally {
      setLoading(false);
    }
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData({
      ...formData,
      [name]: checked,
    });
  };

  return (
    <>
      <Navbar />
      <div className={style.imageContainer}>
        <img
          className={style.heroImg}
          src={images.jobFormHeroImg}
          alt="Hero-img"
        />
        <ToastContainer style={{ zIndex: 100000 }} />
      </div>
      <form className={style.form}>
        <div className={style.heading}>Employment Application</div>
        <div className={style.formInfo}>
          Fill the form below accurately indicating your potentials and
          suitability to job applying for.
        </div>
        <hr id={style.line} />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            // width:"100%"
          }}
        >
          <Box
            className="section"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <Box sx={{ width: "50%", mr: 2 }}>
              <p style={{ fontWeight: "500", fontSize: "17px" }}>
                Full name <span style={{ color: "red" }}>*</span>
              </p>
              <TextField
                id="fullName"
                name="name"
                label="Enter your Name"
                value={formData.name}
                onChange={handleChange}
                variant="outlined"
                fullWidth
                required
                // Adding margin-right for space
              />
            </Box>
            <Box style={{ width: "50%" }}>
              <p style={{ fontWeight: "500", fontSize: "17px" }}>
                Email <span style={{ color: "red" }}>*</span>
              </p>
              <TextField
                id="email"
                name="email"
                label="Enter your Email"
                value={formData.email}
                onChange={handleChange}
                variant="outlined"
                fullWidth
                required
              />
            </Box>
          </Box>
          <Box
            className="section"
            sx={{ display: "flex", justifyContent: "space-between", my: 4 }}
          >
            <Box sx={{ width: "50%", mr: 2 }}>
              <p style={{ fontWeight: "500", fontSize: "17px" }}>
                Date of birth <span style={{ color: "red" }}>*</span>
              </p>
              <TextField
                id="dob"
                // label="Date of Birth *"
                type="date"
                name="dob"
                value={formData.dob}
                onChange={handleChange}
                fullWidth
                required
                sx={{ mr: 2 }} // Adding margin-right for space
              />
            </Box>
            <Box sx={{ width: "50%" }}>
              <p style={{ fontWeight: "500", fontSize: "17px" }}>
                Phone Number <span style={{ color: "red" }}>*</span>
              </p>
              <TextField
                id="number"
                type="tel" // Use "tel" type for phone numbers
                name="phone"
                label="+91 Enter your Number"
                value={formData.phone}
                onChange={handleChange}
                fullWidth
                required
              />
              {/* </div> */}
            </Box>
          </Box>

          <Box
            className="section"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <Box sx={{ width: "50%", mr: 2 }}>
              <p style={{ fontWeight: "500", fontSize: "17px" }}>
                Address <span style={{ color: "red" }}>*</span>
              </p>
              <TextField
                id="address"
                type="text" // Use "tel" type for phone numbers
                name="address"
                label="Enter the address"
                value={formData.address}
                onChange={handleChange}
                fullWidth
                required
              />
              {/* </div> */}
            </Box>
            <Box sx={{ width: "50%" }}>
              <p style={{ fontWeight: "500", fontSize: "17px" }}>
                Work experience <span style={{ color: "red" }}>*</span>
              </p>
              <Select
                id="workExperienceInput"
                name="workExperience"
                value={formData.workExperience}
                onChange={handleChange}
                fullWidth
                required
              >
                <MenuItem value="Select option">Select option</MenuItem>
                <MenuItem value="0">0</MenuItem>
                <MenuItem value="1">1</MenuItem>
                <MenuItem value="2">2</MenuItem>
                <MenuItem value="3">3</MenuItem>
                <MenuItem value="4+">4+</MenuItem>
              </Select>
            </Box>
          </Box>
          <Box
            className="section"
            sx={{ display: "flex", justifyContent: "space-between", my: 4 }}
          >
            <Box sx={{ width: "50%", mr: 2 }}>
              <p style={{ fontWeight: "500", fontSize: "17px" }}>
                Job role <span style={{ color: "red" }}>*</span>
              </p>
              <Select
                id="jobRoleInput"
                name="jobRole"
                fullWidth
                value={formData.jobRole}
                onChange={handleChange}
              >
                <MenuItem value="Select option">Select option</MenuItem>
                <MenuItem value="Full Stack Developer">
                  Full Stack Developer
                </MenuItem>
                <MenuItem value="MERN Stack Developer">
                  MERN Stack Developer
                </MenuItem>
                <MenuItem value="MEAN Stack Developer">
                  MEAN Stack Developer
                </MenuItem>
                <MenuItem value="Frontend Developer">
                  Frontend Developer
                </MenuItem>
                <MenuItem value="Backend Developer">Backend Developer</MenuItem>
                <MenuItem value="DataBase Manager">DataBase Manager</MenuItem>
                <MenuItem value="Python Developer">Python Developer</MenuItem>
                <MenuItem value="Machine Learner">Machine Learner</MenuItem>
                {/* Add more options as needed */}
              </Select>
              {/* </div> */}
            </Box>
            <Box sx={{ width: "50%" }}>
              <p style={{ fontWeight: "500", fontSize: "17px" }}>
                Job type <span style={{ color: "red" }}>*</span>
              </p>
              <Select
                id="jobTypeInput"
                name="jobType"
                value={formData.jobType}
                onChange={handleChange}
                fullWidth
                required
              >
                <MenuItem value="Select option">Select option</MenuItem>
                <MenuItem value="Full Time">Full Time</MenuItem>
                <MenuItem value="Part Time">Part Time</MenuItem>
                <MenuItem value="Internship">Internship</MenuItem>
              </Select>
            </Box>
          </Box>

          <Box
            className="section"
            sx={{ display: "flex", justifyContent: "space-between" }}
          >
            <Box sx={{ width: "50%", mr: 2 }}>
              <p style={{ fontWeight: "500", fontSize: "17px" }}>
                Introduce yourself <span style={{ color: "red" }}>*</span>
              </p>
              <div className="introduction">
                <TextField
                  id="introductionTextarea"
                  name="introduction"
                  label="Tell us about yourself"
                  value={formData.introduction}
                  onChange={handleChange}
                  variant="outlined"
                  multiline
                  minRows={3.8}
                  maxRows={10}
                  fullWidth
                  required
                />
              </div>
            </Box>
            <Box sx={{ width: "50%" }}>
              <p style={{ fontWeight: "500", fontSize: "17px" }}>
                Resume/Cv <span style={{ color: "red" }}>*</span>
              </p>
              <Box
                style={{
                  height: "120px",
                  borderColor: "rgba(0, 0, 0, 0.2)", // Adjust the alpha value (0.5 for 50% opacity)
                  borderWidth: "1px",
                  borderStyle: "solid",
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  alignItems: "center",
                  borderRadius: "5px",
                  width: "100%",
                  cursor: "pointer",
                }}
                onClick={() => document.getElementById("uploadCvInput").click()} // Open file explorer when any part of the div is clicked
              >
                <input
                  type="file"
                  id="uploadCvInput"
                  name="uploadCv"
                  onChange={(e) => handleUploadCv(e, "uploadCv")}
                  style={{ display: "none" }}
                />
                <img
                  src={Images.jobUpload}
                  alt="jobIcon"
                  style={{ height: "40px", width: "23px", cursor: "pointer" }}
                  // onClick={() => document.getElementById("coverLetterInput").click()} // Also open file explorer when the upload icon is clicked
                />
                {formData.uploadCv && (
                  <div
                    onClick={handleOpenCv}
                    className={style.file}
                    style={{ color: "blue", cursor: "pointer" }}
                  >
                    {formData.uploadCv.name} {/* Display file name */}
                  </div>
                )}
                {!formData.uploadCv && (
                  <div className={style.file}>Upload File </div>
                )}
              </Box>
            </Box>
          </Box>
        </div>
        <Box>
          <Box className="section" sx={{ width: "49%", my: 4 }}>
            <p style={{ fontWeight: "500", fontSize: "17px" }}>
              Cover Letter <span style={{ color: "red" }}>*</span>
            </p>
            <Box
              style={{
                height: "120px",
                borderColor: "rgba(0, 0, 0, 0.2)", // Adjust the alpha value (0.5 for 50% opacity)
                borderWidth: "1px",
                borderStyle: "solid",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
                borderRadius: "5px",
              }}
              onClick={() =>
                document.getElementById("coverLetterInput").click()
              } // Open file explorer when any part of the div is clicked
            >
              <input
                type="file"
                id="coverLetterInput"
                name="coverLetter"
                onChange={(e) => handleFileChange(e, "coverLetter")}
                style={{ display: "none" }}
              />
              <img
                src={Images.jobUpload}
                alt="jobIcon"
                style={{ height: "40px", width: "23px", cursor: "pointer" }}
                // onClick={() => document.getElementById("coverLetterInput").click()} // Also open file explorer when the upload icon is clicked
              />
              {formData.coverLetter && (
                <div
                  onClick={handleOpenFile}
                  className={style.file}
                  style={{ color: "blue", cursor: "pointer" }}
                >
                  {formData.coverLetter.name} {/* Display file name */}
                </div>
              )}
              {!formData.coverLetter && (
                <div className={style.file}>Upload File</div>
              )}
            </Box>
          </Box>
          <p className={style.refer}>
            How were you referred to us <span style={{ color: "red" }}>*</span>
          </p>
          <table className={style.checkBoxContainer}>
            <tr>
              <td>
                <FormControlLabel
                  control={
                    <Checkbox
                      id="walkIN"
                      name="refer"
                      checked={formData.refer === "walkIN"}
                      onChange={handleChange}
                      value="walkIN"
                    />
                  }
                  label="Walk-in"
                />
              </td>
              <td>
                <FormControlLabel
                  control={
                    <Checkbox
                      id="linkedIn"
                      name="refer"
                      checked={formData.refer === "linkedIn"}
                      onChange={handleChange}
                      value="linkedIn"
                    />
                  }
                  label="Linkedin"
                />
              </td>
              <td>
                <FormControlLabel
                  control={
                    <Checkbox
                      id="twitter"
                      name="refer"
                      checked={formData.refer === "twitter"}
                      onChange={handleChange}
                      value="twitter"
                    />
                  }
                  label="Twitter"
                />
              </td>
            </tr>
            <tr>
              <td>
                <FormControlLabel
                  control={
                    <Checkbox
                      id="facebook"
                      name="refer"
                      checked={formData.refer === "facebook"}
                      onChange={handleChange}
                      value="facebook"
                    />
                  }
                  label="Facebook"
                />
              </td>
              <td>
                <FormControlLabel
                  control={
                    <Checkbox
                      id="referral"
                      name="refer"
                      checked={formData.refer === "referral"}
                      onChange={handleChange}
                      value="referral"
                    />
                  }
                  label="Referral"
                />
              </td>
              <td>
                <FormControlLabel
                  control={
                    <Checkbox
                      id="other"
                      name="refer"
                      checked={formData.refer === "other"}
                      onChange={handleChange}
                      value="other"
                    />
                  }
                  label="Other"
                />
              </td>
            </tr>
          </table>
        </Box>

        <div className={style.referenceSection}>References (if any)</div>
        <div>Please list references that are familiar with your work life.</div>
        <Box
          className="section"
          sx={{ display: "flex", justifyContent: "space-between", my: 4 }}
        >
          <Box sx={{ width: "50%", mr: 2 }}>
            <p style={{ fontWeight: "500", fontSize: "18px" }}>
              Name <span style={{ color: "red" }}>*</span>
            </p>
            <TextField
              id="referencePersonName"
              name="referencePersonName"
              label="Enter the full name"
              value={formData.referencePersonName}
              onChange={handleChange}
              variant="outlined"
              fullWidth
              required
              // Adding margin-right for space
            />
          </Box>
          <Box style={{ width: "50%" }}>
            <p style={{ fontWeight: "500", fontSize: "18px" }}>
              Title <span style={{ color: "red" }}>*</span>
            </p>
            <TextField
              id="referencePersonTitle"
              name="referencePersonDesignation"
              label="Enter designation"
              value={formData.referencePersonDesignation}
              onChange={handleChange}
              variant="outlined"
              fullWidth
              required
            />
          </Box>
        </Box>
        <Box
          className="section"
          sx={{ display: "flex", justifyContent: "space-between", my: 4 }}
        >
          <Box sx={{ width: "50%", mr: 2 }}>
            <p style={{ fontWeight: "500", fontSize: "18px" }}>
              Relationship <span style={{ color: "red" }}>*</span>
            </p>
            <TextField
              id="referencePersonRelationship"
              name="referencePersonRelationship"
              label="Enter your relationship to them"
              value={formData.referencePersonRelationship}
              onChange={handleChange}
              variant="outlined"
              fullWidth
              required
              // Adding margin-right for space
            />
          </Box>
          <Box style={{ width: "50%" }}>
            <p style={{ fontWeight: "500", fontSize: "18px" }}>
              Email <span style={{ color: "red" }}>*</span>
            </p>
            <TextField
              id="referencePersonEmail"
              name="referencePersonEmail"
              label="Enter email"
              value={formData.referencePersonEmail}
              onChange={handleChange}
              variant="outlined"
              fullWidth
              required
            />
          </Box>
        </Box>
        <Box
          className="section"
          sx={{ display: "flex", justifyContent: "space-between", my: 4 }}
        >
          <Box sx={{ width: "50%", mr: 2 }}>
            <p style={{ fontWeight: "500", fontSize: "18px" }}>
              Linkedin <span style={{ color: "red" }}>*</span>
            </p>
            <TextField
              id="referencePersonLinkedin"
              name="referencePersonLinkedin"
              label="Enter linkedin profile"
              value={formData.referencePersonLinkedin}
              onChange={handleChange}
              variant="outlined"
              fullWidth
              required
              // Adding margin-right for space
            />
          </Box>
        </Box>

        <div className={style.tcContainer}>
          <input
            // aria-disabled={false}
            type="checkbox"
            id="T&C"
            name="termsCheckbox"
            // checked={formData.termsCheckbox}
            onChange={handleCheckboxChange}
            style={{ marginRight: "10px", transform: "scale(1.5)" }}
          />
          <label htmlFor="T&C" className={style.terms}>
            I accept the<span className={style.blue}> terms</span> and{" "}
            <span className={style.blue}>conditions</span>
          </label>
        </div>
        <Button
          onClick={handleSubmit}
          disabled={loading}
          style={{ height: "45px", backgroundColor: "#192BC2", color: "white" }}
        >
          Submit my application
        </Button>
      </form>
      <Footer />
    </>
  );
};

export default JobFormScreen;
